<template>
    <router-link :to="{ name: 'complex', params: { id: complexData.id } }" target="_blank">
        <div class="search-item">
            <div class="search-item__img-container">
                <img class="search-item__img" :src="complexData.photo_url" alt="фото жк">
            </div>
            <div class="search-item__all-info">
                <p class="search-item__name">{{ complexData.name }}</p>
                <div>
                    <div class="search-item__info-container">
                        <div class="search-item__info">
                            <div class="search-item__info__left">
                                <div v-for="metroItem in complexData.metro" class="metro-item">
                                    <span class="metro-item__color"
                                        :style="'background-color:' + checkMetro(metroItem.name_metro) + ';'"></span>
                                    <span class="metro-item__name">{{ metroItem.name_metro }}, {{ metroItem.time_metro
                                    }}</span>
                                </div>
                                <p class="search-item__address">{{ complexData.address }}</p>
                                <p class="search-item__desc">{{ complexData.finish }}</p>
                            </div>
                            <div>
                                <p class="search-item__date">Сдан – {{ complexData.key_handover_time }}</p>
                                <p class="search-item__developer">Застройщик: {{ complexData.developer }}</p>
                                <p class="search-item__apartments-count">Квартир {{ complexData.apartments_count }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="search-item__apartment">
                        <ul>
                            <li v-for="apartment in complexData.queue_list">
                                <span>{{ apartment.type }}</span>
                                <span class="dotted-line"></span>
                                <span>от {{ parseInt(apartment.min_cost).toLocaleString('ru-RU') }} ₽</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    name: 'ComplexItem',
    props: {
        complexData: {
            type: Object,
            default() {
                return {
                    name: ''
                }
            }
        }
    },
    data() {
        return {
            isStartSellShow: false,
            metroList: [
                "Девяткино",
                "#BB2F30",
                "Гражданский проспект",
                "#BB2F30",
                "Академическая",
                "#BB2F30",
                "Политехническая",
                "#BB2F30",
                "Площадь Мужества",
                "#BB2F30",
                "Лесная",
                "#BB2F30",
                "Выборгская",
                "#BB2F30",
                "Площадь Ленина",
                "#BB2F30",
                "Чернышевская",
                "#BB2F30",
                "Площадь Восстания",
                "#BB2F30",
                "Владимирская",
                "#BB2F30",
                "Пушкинская",
                "#BB2F30",
                "Технологический институт",
                "#4B74C0",
                "Балтийская",
                "#BB2F30",
                "Нарвская",
                "#BB2F30",
                "Кировский завод",
                "#BB2F30",
                "Автово",
                "#BB2F30",
                "Ленинский проспект",
                "#BB2F30",
                "Проспект Ветеранов",
                "#BB2F30",
                "Беговая",
                "#7BBD5A",
                "Новокрестовская",
                "#7BBD5A",
                "Приморская",
                "#7BBD5A",
                "Василеостровская",
                "#7BBD5A",
                "Гостиный двор",
                "#7BBD5A",
                "Маяковская",
                "#7BBD5A",
                "Площадь Александра Невского",
                "#7BBD5A",
                "Площадь Ал. Невского - 1",
                "#7BBD5A",
                "Елизаровская",
                "#7BBD5A",
                "Ломоносовская",
                "#7BBD5A",
                "Пролетарская",
                "#7BBD5A",
                "Обухово",
                "#7BBD5A",
                "Рыбацкое",
                "#7BBD5A",
                "Спасская",
                "#EDC738",
                "Достоевская",
                "#EDC738",
                "Лиговский проспект",
                "#EDC738",
                "Площадь Ал. Невского - 2",
                "#EDC738",
                "Новочеркасская",
                "#EDC738",
                "Ладожская",
                "#EDC738",
                "Проспект Большевиков",
                "#EDC738",
                "Улица Дыбенко",
                "#EDC738",
                "Парнас",
                "#4B74C0",
                "Проспект Просвещения",
                "#4B74C0",
                "Озерки",
                "#4B74C0",
                "Удельная",
                "#4B74C0",
                "Пионерская",
                "#4B74C0",
                "Чёрная речка",
                "#4B74C0",
                "Петроградская",
                "#4B74C0",
                "Горьковская",
                "#4B74C0",
                "Невский проспект",
                "#4B74C0",
                "Сенная площадь",
                "#4B74C0",
                "Фрунзенская",
                "#4B74C0",
                "Московские ворота",
                "#4B74C0",
                "Электросила",
                "#4B74C0",
                "Парк Победы",
                "#4B74C0",
                "Московская",
                "#4B74C0",
                "Звёздная",
                "#4B74C0",
                "Купчино",
                "#4B74C0",
                "Комендантский проспект",
                "#77369A",
                "Старая Деревня",
                "#77369A",
                "Крестовский остров",
                "#77369A",
                "Чкаловская",
                "#77369A",
                "Спортивная",
                "#77369A",
                "Адмиралтейская",
                "#77369A",
                "Садовая",
                "#77369A",
                "Звенигородская",
                "#77369A",
                "Обводный канал",
                "#77369A",
                "Волковская",
                "#77369A",
                "Бухарестская",
                "#77369A",
                "Международная",
                "#77369A",
                "Проспект Славы",
                "#77369A",
                "Шушары",
                "#77369A"
            ]
        }
    },
    methods: {
        checkMetro(name) {
            return this.metroList[this.metroList.indexOf(name) + 1]
        },
    }

}
</script>

<style lang="scss">
.search-item {
    display: flex;

    padding: 20px;

    border: 1px solid;
    border-radius: 10px;

    border: 1px solid rgb(168, 168, 168);

    background-color: white;

    color: $font-color;

    transition: box-shadow .3s;

    &:hover {
        box-shadow: 0 0 20px rgba(99, 99, 99, 0.329);
    }

    &__all-info {
        width: 100%;
        margin-left: 20px;

        >div {
            margin-top: 20px;

            display: flex;
        }
    }

    &__img-container {
        max-width: 280px;

        position: relative;
        margin-left: 0;

        div {
            position: absolute;

            left: 15px;
            top: 80px;
        }

        span {
            font-size: 12px;
            line-height: 105%;
            padding: 3px;

            color: $font-color;
            background-color: white;

            &:first-of-type {
                border-radius: 5px 5px 0 0;
            }

            &:last-of-type {
                border-radius: 0 0 5px 5px;
            }
        }
    }

    &__img {
        width: 100%;
        max-height: 190px;

        border-radius: 10px;
    }

    &__name {
        @extend %BODY1;
        font-size: 18px;
        font-weight: 600;
    }

    &__info-container {
        margin-right: 20px;
        width: 100%;
    }

    &__info {
        display: flex;
        width: 100%;

        &__left {
            min-width: 45%;
            max-width: 45%;
        }

        div {
            p:not(:first-of-type) {
                margin-top: 5px;
            }
        }

        >div:last-of-type {
            margin-left: 35px;
        }
    }

    &__address {
        margin-top: 10px;
    }

    &__desc {
        color: $second-font-color;
    }

    &__apartment-count {
        color: $second-font-color;
    }

    .metro-item {
        display: flex;
        align-items: center;

        &__color {
            display: block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            margin-top: 1px;
        }

        &__name {
            color: $second-font-color;
            margin-left: 5px;
        }
    }

    &__apartment {
        margin-left: auto;

        width: 100%;
        max-width: 300px;

        li {
            &:not(:first-of-type) {
                margin-top: 10px;
            }

            display: flex;
            justify-content: space-between;

            span:first-of-type {
                color: $second-font-color;
            }

            .dotted-line {
                content: "";

                height: 2px;

                width: 100%;

                border-bottom: 1px dotted #ccc;

                align-self: flex-end;

                margin: 4px 5px;

                flex: 1 1 0;
            }
        }
    }
}

@media screen and (max-width: 1200px) {
    .search-item {
        &__all-info {
            >div {
                flex-direction: column;
            }
        }

        &__info {
            justify-content: space-between;

        }

        &__apartment {
            margin-left: 0;
            margin-top: 20px;
            max-width: none;
        }
    }
}

@media screen and (max-width:800px) {
    .search-item {
        flex-direction: column;

        padding: 10px;

        &__name {
            margin-top: 10px;
        }

        &__info {
            flex-direction: column;

            &__left {
                width: 100%;
            }

            >div:last-of-type {
                margin-left: 0;
                margin-top: 20px;
            }
        }

        &__img-container {
            max-width: none;
            width: 100%;

            div {
                top: auto;
                bottom: 30px;
            }

        }

        &__all-info {
            margin-left: 0;
        }
    }
}
</style>